import { render, staticRenderFns } from "./AlertResponsePage.vue?vue&type=template&id=480f931c&scoped=true&"
import script from "./AlertResponsePage.vue?vue&type=script&lang=js&"
export * from "./AlertResponsePage.vue?vue&type=script&lang=js&"
import style0 from "./AlertResponsePage.vue?vue&type=style&index=0&id=480f931c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480f931c",
  null
  
)

export default component.exports